// Google Tag Manager utility functions

// Initialize dataLayer array if it doesn't exist
export const initDataLayer = () => {
  window.dataLayer = window.dataLayer || [];
};

// Push an event to the dataLayer
export const pushEvent = (event: string, data: Record<string, any> = {}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      ...data
    });
  }
};

// Track page view
export const trackPageView = (path: string, title: string) => {
  pushEvent('pageView', {
    page: {
      path,
      title
    }
  });
};

// Track user interaction
export const trackInteraction = (category: string, action: string, label?: string, value?: number) => {
  pushEvent('interaction', {
    category,
    action,
    label,
    value
  });
};